import React, { useEffect, useState } from 'react';
import { SimpleEntity } from '../../../types/purchases/BasePurchase';
import SelectField from '../../../components/Forms/Input/SelectField';
import SaleTableModal from '../../../components/Tables/SaleTableModal';
import { useSale } from '../../../hooks/sale/useSale';
import { PendingSaleSummary } from '../../../types/sale/dto/PendingSaleSummary';
import MobileTable from '../../../components/Tables/mobile/MobileTable';
import DesktopTable from '../../../components/Tables/desktop/DesktopTable';
import { useSalesButtonActions } from '../../../hooks/sale/useSalesButtonConfig';

interface PendingSaleModalProps {
  isOpen: boolean;
  onClose: () => void;
  sales: PendingSaleSummary[];
  branches: SimpleEntity[];
}

const PendingSaleModal: React.FC<PendingSaleModalProps> = ({
  isOpen,
  onClose,
  sales,
  branches,
}) => {
  const { handlerGetPendingSummary, handlerGetSaleToContinue } = useSale();

  const { handlerCancelPendingSale} = useSalesButtonActions();

  const [selectedBranch, setSelectedBranch] = useState<string>('');

  useEffect(() => {
    if (isOpen) {
      handlerGetPendingSummary();
    }
  }, [isOpen]);

  useEffect(() => {
    if (selectedBranch) {
      handlerGetPendingSummary(Number(selectedBranch));
    }
  }, [selectedBranch]);

  // columnas
  const columns = [
    { accessor: 'documentType', label: 'Tipo de Documento' },
    { accessor: 'customerName', label: 'Cliente' },
    { accessor: 'saleDate', label: 'Fecha de Documento' },
    { accessor: 'total', label: 'Total Factura' },
  ];

  // acciones
  const actions = [
    {
      label: 'Continuar',
      icon: 'continue',
      onClick: (row: PendingSaleSummary) => handlerGetSaleToContinue(row.id),
    },
    {
      label: 'Cancelar',
      icon: 'cancel',
      color: 'danger',
      onClick: (row: PendingSaleSummary) => handlerCancelPendingSale(row.id),
    },
  ];

  return (
    <SaleTableModal
      isOpen={isOpen}
      onClose={onClose}
      title="Ventas Pendientes"
      maxWidth="max-w-7xl"
    >
      <div className="max-h-[70vh] overflow-y-auto px-6 py-4">
        {/* Filtro de sucursal */}
        <div className="mb-4 w-full sm:w-1/3">
          <SelectField
            label="Filtrar por Sucursal"
            name="branch"
            value={selectedBranch}
            onChange={(e) => setSelectedBranch(e.target.value)}
            options={branches.map((b) => ({
              value: b.id,
              label: b.name,
            }))}
            iconKey="search"
            placeholder="Seleccione una sucursal"
          />
        </div>

        {/* Tabla Mobile */}
        <div className="block lg:hidden">
          <MobileTable
            title="Ventas Pendientes"
            description="Continúa una venta previamente iniciada."
            data={sales}
            columns={columns}
            actions={actions}
            noDataMessage="No hay ventas pendientes."
          />
        </div>

        {/* Tabla Escritorio */}
        <div className="hidden lg:block">
          <DesktopTable
            data={sales}
            columns={columns}
            actions={actions}
            noDataMessage="No hay ventas pendientes."
          />
        </div>
      </div>
    </SaleTableModal>
  );
};

export default PendingSaleModal;
